import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Divider, Row } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
//Ducks
import { download } from "../../../../redux/aspirante/reqAcademicoDuck";
import * as ducks from "../../../../redux/aspirante/expDigitalDucks";
//Utils
import { ERROR_ARCHIVO, openNotification } from "../../../../utils";

/**
 * Componente que muestra y permite la descargar los formatos del expediente digital
 * @return {JSX.Element}
 * @author Uriel Carrión
 */
export const DescargaFormatos = () => {
  const dispatch = useDispatch();
  //State
  const { catalogoFormatos } = useSelector((state) => state.expDigital);

  /**
   * Permite descargar el archivo de privacidad
   * @param {object} item - del aviso de privacidad
   */
  const downloadDocument = (item) => {
    const { rutaArchivo, nombreDocumento } = item;
    const extension = rutaArchivo.split('.').pop();
    
    dispatch(ducks.setLoading(true));
    // Se envía la ruta del archivo
    dispatch(download(rutaArchivo))
      .then(({ data }) => {
        data && saveAs(new Blob([data]), `${nombreDocumento}.${extension}`);
        dispatch(ducks.setLoading(false));
      })
      .catch((error) => {
        openNotification("warning", "Atención", ERROR_ARCHIVO);
        dispatch(ducks.setLoading(false));
      });
  };

  return (
    <div className="exp-formato-content">
      <h2 style={{ fontWeight: 300 }}>¡Recuerda!</h2>
      <Row gutter={24}>
        {/* ------------------------- Descripciones ---------------------------------- */}
        <Col span={11} xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
          <Row>
            <Col span={1} xxl={1} xl={1} lg={1} md={1} sm={24} xs={24}>
              <div className="exp-numero-requisito">1</div>
            </Col>
            <Col span={23} xxl={23} xl={23} lg={23} md={23} sm={24} xs={24}>
              <div className="exp-requisitos">Descargar los formatos.</div>
            </Col>
          </Row>
          <Row>
            <Col span={1} xxl={1} xl={1} lg={1} md={1} sm={24} xs={24}>
              <div className="exp-numero-requisito">2</div>
            </Col>
            <Col span={23} xxl={23} xl={23} lg={23} md={23} sm={24} xs={24}>
              <div className="exp-requisitos">
                Completarlos con la información que éstos solicitan.
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={1} xxl={1} xl={1} lg={1} md={1} sm={24} xs={24}>
              <div className="exp-numero-requisito">3</div>
            </Col>
            <Col span={23} xxl={23} xl={23} lg={23} md={23} sm={24} xs={24}>
              <div className="exp-requisitos">
                Agregarlos al listado de documentos adjuntos.
              </div>
            </Col>
          </Row>
        </Col>

        <Col span={1} xxl={1} xl={1} lg={1} md={1} sm={24} xs={24}>
          <Divider type="vertical" className="expediente-divider " />
        </Col>

        {/* -------------------------- Archivos a Descargar ---------------------------------- */}
        <Col span={12} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
          {catalogoFormatos.map((item) => (
            <li
              className="link descarga-ayuda"
              key={item.idDocumento}
              onClick={() => downloadDocument(item)}
            >
              <DownloadOutlined /> {item.nombreDocumento}
            </li>
          ))}
        </Col>
      </Row>
    </div>
  );
};
